import { useState, useRef } from "react";

export function useReadMore(maxLines = 2) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedItems, setExpandedItems] = useState<Record<number, boolean>>({});
  const paragraphRef = useRef<HTMLParagraphElement>(null);
  const paragraphRefs = useRef<(HTMLElement | null)[]>([]);

  const toggleReadMore = (index?: number) => () => {
    if (index !== undefined) {
      setExpandedItems(prevState => ({
        ...prevState,
        [index]: !prevState[index],
      }));
      if (paragraphRefs.current[index]) {
        paragraphRefs.current[index]!.style.maxHeight = !expandedItems[index] ? `${paragraphRefs.current[index]!.scrollHeight}px` : `${maxLines * 32}px`;
      }
    } else {
      setIsExpanded(!isExpanded);
      if (paragraphRef.current) {
        paragraphRef.current.style.maxHeight = !isExpanded ? `${paragraphRef.current.scrollHeight}px` : `${maxLines * 32}px`;
      }
    }
  };

  const readMoreClasses = {
    maxHeight: isExpanded ? "500px" : `${maxLines * 32}px`,
  };

  return { isExpanded, expandedItems, toggleReadMore, paragraphRef, paragraphRefs, readMoreClasses };
}
